import { Button, List, Modal } from '@ksyos/design-system';
import type { IPatient } from '@common/interfaces/patient';
import { getLanguage } from '@common/translate/translate';

export function MissingPatientDetailsModal(props: {
    isOpen: boolean;
    onClose: (isOpen: boolean) => void;
    patient: IPatient;
}) {
    const { isOpen, onClose, patient } = props;
    const translate = getLanguage();

    return (
        <Modal
            isOpen={isOpen}
            onClose={() => onClose(false)}
            size="small"
        >
            <Modal.Header>Missende patiëntgegevens</Modal.Header>
            <Modal.CloseButton />
            <Modal.Body>
                Om een afspraak in te plannen, moeten de volgende gegevens van de patiënt bekend zijn:
                <List
                    size="small"
                    styleType="bullet"
                    sx={{ mb: 4, mt: 4 }}
                >
                    {!patient?.homePhoneNumber && !patient?.mobileNumber ? (
                        <List.Item>Tenminste één telefoonnummer</List.Item>
                    ) : (
                        ''
                    )}
                    {!patient?.emailAddress ? <List.Item>Het e-mailadres</List.Item> : ''}
                </List>
                Voeg deze informatie toe via &apos;Wijzig patiëntgegevens&apos;.
            </Modal.Body>
            <Modal.Footer>
                <Button
                    onClick={() => {
                        onClose(false);
                    }}
                >
                    {translate.common.closeShort}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
